import * as React from 'react'

export interface IALinkProps {
  url: string
  className?: string
  style?: any
}

export const ALink: React.SFC<IALinkProps> = (props) => {
  return (
    <a
      href={props.url}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      style={props.style}
      className={props.className}
      target='_blank'
      rel='noopener noreferrer'
    >
      {props.children}
    </a>
  )
}
